<template>
  <c-dialog ref="dialog" height="350" width="600" @resolve="editHandle">
    <c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="分类" required tip="请选择关联分类">
        <c-select name="category_id" async @search="searchCategory" v-model="categoryId" :value-data="selectedCategory" :disabled="!changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="分组" required tip="请选择关联分组">
        <c-select name="release_group_id" async @search="searchGroup" :value-data="selectedGroup" :disabled="!categoryId || !changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="质检项名称" required tip="同一分组下，名称不允许重复">
        <c-input name="name" maxlength="100"></c-input>
      </c-form-item>
      <c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
      </c-form-item>
    </c-form>
  </c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
  },

  data() {
    return {
      changeGroupFlag:false,//是否允许变更所属分组  true = 允许 （树形表格中不允许变更上级）
      editState: false,
      categoryId:0,
      selectedCategory:[], //已选中的分类
      selectedGroup:[] //已选中的分组
    }
  },

  methods: {
    /*******搜索分类*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*******搜索分组*****************/
    searchGroup(keyword, resolve){
      this.request({
        url:'/spu/release/parent/options',
        data: {
          category_id:this.categoryId,
          keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*******通过ID查询分组详情*****************/
    getGroupDetail(release_group_id){
      this.request({
        url:'/spu/release/group/detail',
        data: {
            id:release_group_id
        },
        success:data => {
          this.selectedCategory= [{
              name: data.category_name,
              value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
              name: data.group_name,
              value:data.id
          }];
        }
      })
    },

    /*********打开编辑框，初始化**********/
    open(data,release_group_id) {
      this.editState = !!data;
      this.changeGroupFlag = !release_group_id;
      this.$refs.form.clear();
      if (data) {
          //已选中的[分类]
          this.selectedCategory = [{
              name: data.category_name,
              value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
              name: data.group_name,
              value:data.release_group_id
          }];
          this.$refs.form.set(data);
      }else {
          this.getGroupDetail(release_group_id);
      }
      //填充form表单
      this.$refs.dialog.open({
        title: data ? '编辑质检项' : '添加质检项'
      });
    },

    /*******添加、编辑提交处理方法********/
    editHandle (stop, next){
      stop();
      this.$refs.form.submit({
        url: this.editState?'/spu/release/parent/edit':'/spu/release/parent/add',
        rule: {
          category_id: '请选择关联的分类',
          release_group_id: '请选择关联的分组',
          name: '请输入质检项名称'
        },
        dataFormatter: data => {
          return data;
        },
        success: (data, res) => {
          next();
          if(this.editState){
            this.$message({
              message: '编辑成功',  // 提示内容,
              type: 'success'
            });
          }else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
          }
          this.$emit('resolve',res);
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>